import { render, staticRenderFns } from "./DinCarouselView.vue?vue&type=template&id=5d95deb9&scoped=true"
import script from "./DinCarouselView.vue?vue&type=script&lang=js"
export * from "./DinCarouselView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95deb9",
  null
  
)

export default component.exports